<template>
  <div>
    <user-password-edit :user-info="userInfo" />
    <b-card no-body class="mb-0">
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Show</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>entries</label>
          </b-col>

          <!-- Search -->
          <b-col cols="12" md="6">
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Search..."
              />
              <b-button
                variant="primary"
                v-if="true || ability.can('create', 'users')"
                @click="isAddNewUserSidebarActive = true"
                :to="{ name: 'users-create' }"
                class="mr-1"
              >
                <span class="text-nowrap">Add Company</span>
              </b-button>
              <b-button
                variant="success"
                @click="syncDatabase"
                :disabled="isSyncingDatabase"
              >
                <b-spinner
                  v-if="isSyncingDatabase"
                  small
                  class="mr-1"
                />
                <span class="text-nowrap">{{ isSyncingDatabase ? '整合中...' : '整合DB' }}</span>
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>

      <b-table
        ref="refUserListTable"
        class="position-relative"
        :items="fetchUsers"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc"
      >
        <template #cell(image_url)="data">
          <b-img
            rounded
            blank-color="#5A8DEE"
            alt="Rounded image"
            :src="data.item.image_url"
            class="d-inline-block mr-1 mb-1 user-image"
            v-if="data.item.image_path"
          />
        </template>

        <!-- Column: User -->
        <template #cell(user)="data">
          <b-media vertical-align="center">
            <template #aside>
              <b-avatar
                size="32"
                :src="data.item.avatar"
                :text="avatarText(data.item.fullName)"
                :variant="`light-${resolveUserRoleVariant(data.item.role)}`"
                :to="{ name: 'apps-users-view', params: { id: data.item.id } }"
              />
            </template>
            <b-link
              :to="{ name: 'apps-users-view', params: { id: data.item.id } }"
              class="font-weight-bold d-block text-nowrap"
            >
              {{ data.item.fullName }}
            </b-link>
            <small class="text-muted">@{{ data.item.username }}</small>
          </b-media>
        </template>
        <!-- Column: roles  -->
        <template #cell(role)="data">
          <div v-if="data.item.role">
            <span v-for="item in data.item.role" :key="item.id">{{
              item.name
            }}</span>
          </div>
        </template>
        <!--Column: Position -->
        <template #cell(position_id)="data">
          <div v-if="data.item.position">{{ data.item.position.position }}</div>
        </template>

        <!--Column: Team Lewader -->

        <template #cell(is_teamleader)="data">
          <b-badge
            pill
            v-if="data.item.is_teamleader"
            :variant="`light-primary`"
            class="text-capitalize"
          >
            Team Leader
          </b-badge>
        </template>
        <!-- Column: Team -->
        <template #cell(team_id)="data">
          <b-badge
            v-for="team in data.item.teams"
            :key="team.id"
            class="text-capitalize"
          >
            {{ team.team_name }}
          </b-badge>
        </template>

        <template #cell(is_active)="data">
          <feather-icon
            v-if="data.item.is_active"
            icon="CheckIcon"
            size="18"
            class="mr-50 text-success"
          />
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >
            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <b-dropdown-item
              v-if="true || ability.can('update', 'users')"
              :to="{ name: 'users-edit', params: { id: data.item.id } }"
            >
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Edit</span>
            </b-dropdown-item>
            <b-dropdown-item
              v-if="true || ability.can('update', 'users')"
              @click="triggerResetPasswordModal(data.item)"
            >
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Reset Password</span>
            </b-dropdown-item>
            <b-dropdown-item
              v-if="data.item.db_database"
              @click="migrate(data.item.id)"
            >
              <feather-icon icon="UploadCloudIcon" />
              <span class="align-middle ml-50">上傳公司資料到Allinone</span>
            </b-dropdown-item>
            <b-dropdown-item
             v-if="data.item.db_database"
              @click="migrateProducts(data.item.id)"
            >
              <feather-icon icon="UploadCloudIcon" />
              <span class="align-middle ml-50">上傳產品資料到Allinone</span>
            </b-dropdown-item>
            <b-dropdown-item
             v-if="data.item.db_database"
              @click="migrateDescription(data.item.id)"
            >
              <feather-icon icon="UploadCloudIcon" />
              <span class="align-middle ml-50">上傳公司簡介到Allinone</span>
            </b-dropdown-item>
            <b-dropdown-item
              v-if="data.item.folder_name"
              @click="copyFile(data.item.id)"
            >
              <feather-icon icon="LinkIcon" />
              <span class="align-middle ml-50">複製圖片到Allinone</span>
            </b-dropdown-item>
            <b-dropdown-item
              v-if="data.item.db_database"
              @click="updatePermission(data.item.id)"
            >
              <feather-icon icon="LinkIcon" />
              <span class="align-middle ml-50">更新用戶權限</span>
            </b-dropdown-item>
            <!--
            <b-dropdown-item v-if="ability.can('delete','users')">
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">Delete</span>
            </b-dropdown-item>
            -->
          </b-dropdown>
        </template>
      </b-table>
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted"
              >Showing {{ dataMeta.from }} to {{ dataMeta.to }} of
              {{ dataMeta.of }} entries</span
            >
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalUsers"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BImg,
  BSpinner,
} from "bootstrap-vue";
import vSelect from "vue-select";
import store from "@/store";
import { ref, onUnmounted } from "@vue/composition-api";
import { avatarText } from "@core/utils/filter";
import useUsersList from "./useUsersList";
import userStoreModule from "../userStoreModule";
import UserListAddNew from "./UserListAddNew.vue";
import UserPasswordEdit from "./UserPasswordEdit.vue";

export default {
  components: {
    UserListAddNew,
    UserPasswordEdit,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    vSelect,
    BImg,
    BSpinner,
  },
  methods: {
    migrate(id) {
      this.$swal({
        title: "確定上傳？",
        text: "上傳後將無法回復",
        showCancelButton: true,
        confirmButtonText: "確定",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("app-user/migrateUser", { id })
            .then((response) => {
              console.log("response", response);
              this.$swal({
                text: response.data.message,
                icon: "success",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.refetchData();
            })
            .catch((error) => {
              console.log(error);
              this.$swal({
                text: JSON.stringify(error.response.data.message),
                icon: "error",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
    migrateProducts(id) {
      this.$swal({
        title: "確定上傳？",
        text: "上傳後將無法回復",
        showCancelButton: true,
        confirmButtonText: "確定",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("app-user/migrateProducts", { id })
            .then((response) => {
              console.log("response", response);
              this.$swal({
                text: response.data.message,
                icon: "success",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.refetchData();
            })
            .catch((error) => {
              console.log(error);
              this.$swal({
                text: JSON.stringify(error.response.data.message),
                icon: "error",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
    updatePermission(id) {
      this.$swal({
        title: "更新Store Manager 權限",
        text: "",
        showCancelButton: true,
        confirmButtonText: "更新",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("app-user/updatePermission", { id })
            .then((response) => {
              console.log("response", response);
              this.$swal({
                text: response.data.message,
                icon: "success",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.refetchData();
            })
            .catch((error) => {
              console.log(error);
              this.$swal({
                text: JSON.stringify(error.response.data.message),
                icon: "error",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
    copyFile(id) {
      this.$swal({
        title: "複製圖片到Allinone",
        text: "確認將後台圖片檔案複製到Allinone嗎？",
        showCancelButton: true,
        confirmButtonText: "複製",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("app-user/copyFile", { id })
            .then((response) => {
              console.log("response", response);
              this.$swal({
                text: response.data.message,
                icon: "success",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.refetchData();
            })
            .catch((error) => {
              console.log(error);
              this.$swal({
                text: JSON.stringify(error.response.data.message),
                icon: "error",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
    migrateDescription(id) {
      this.$swal({
        title: "確定上傳？",
        text: "上傳後將無法回復",
        showCancelButton: true,
        confirmButtonText: "確定",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("app-user/migrateDescription", { id })
            .then((response) => {
              console.log("response", response);
              this.$swal({
                text: response.data.message,
                icon: "success",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.refetchData();
            })
            .catch((error) => {
              console.log(error);
              this.$swal({
                text: JSON.stringify(error.response.data.message),
                icon: "error",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
    syncDatabase() {
      this.$swal({
        title: "確定整合資料庫？",
        text: "此操作將自動設定所有用戶的資料庫名稱和資料夾名稱",
        showCancelButton: true,
        confirmButtonText: "確定",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.isSyncingDatabase = true;
          this.$store
            .dispatch("app-user/syncDatabase")
            .then((response) => {
              console.log("response", response);
              this.$swal({
                text: response.data.message,
                icon: "success",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.refetchData();
            })
            .catch((error) => {
              console.log(error);
              this.$swal({
                text: error.response?.data?.message || "整合資料庫時發生錯誤",
                icon: "error",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            })
            .finally(() => {
              this.isSyncingDatabase = false;
            });
        }
      });
    },
    triggerResetPasswordModal(item) {
      console.log("triggerResetPasswordModal", item);
      this.userInfo.id = item.id;
      this.userInfo.name = item.name;
      this.userInfo.password = "";
      this.userInfo.password_confirmation = "";
      this.$bvModal.show("modal-reset-user-password");
    },
  },
  data() {
    return {
      userInfo: { id: 0, password: "", password_confirmation: "" },
      isSyncingDatabase: false,
    };
  },
  setup() {
    const USER_APP_STORE_MODULE_NAME = "app-user";

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME))
      store.registerModule(USER_APP_STORE_MODULE_NAME, userStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME))
        store.unregisterModule(USER_APP_STORE_MODULE_NAME);
    });

    const isAddNewUserSidebarActive = ref(false);

    const statusOptions = [
      { label: "Pending", value: "pending" },
      { label: "Active", value: "active" },
      { label: "Inactive", value: "inactive" },
    ];

    const {
      fetchUsers,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,

      statusFilter,
      ability,
    } = useUsersList();

    return {
      // Sidebar
      isAddNewUserSidebarActive,

      fetchUsers,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,
      ability,

      // Filter
      avatarText,
      statusOptions,

      statusFilter,
    };
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

.user-image {
  width: 100px;
  width: 100px;
  object-fit: contain;
}
</style>
